import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from './Constants';

const AdminGeneralSettingPage = ({ clickChangeMenu }) => {
    const [settings, setSettings] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('General');

    const tabs = [
        { id: 'General', name: 'Tùy chỉnh' },
        { id: 'LienHe', name: 'Liên hệ' },
        { id: 'Email', name: 'Email' },
        { id: 'Social', name: 'Mạng xã hội' },
        { id: 'SEO', name: 'SEO' },
        { id: 'Tools', name: 'Công cụ hỗ trợ' },
        { id: 'Banner', name: 'Banner trang chủ' },
        { id: 'Media', name: 'Audio Video' },
        { id: 'TamDong', name: 'Tạm đóng Website' }
    ];

    const fetchSettings = async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_URL}/settings`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSettings(res.data);
        } catch (err) {
            console.error("Error fetching settings:", err);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const renderField = (label, code, type = 'text') => {
        const item = settings.find(s => s.code === code) || { value: '' };
        return (
            <div className="control-group" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                <label className="control-label" style={{ width: '150px', fontWeight: 'bold', textAlign: 'right', marginRight: '20px' }}>{label}</label>
                <div className="controls" style={{ flex: 1 }}>
                    {type === 'textarea' ? (
                        <textarea className="span12" rows="4" defaultValue={item.value} style={{ width: '100%', borderRadius: '4px' }} />
                    ) : (
                        <div className="input-append" style={{ width: '100%', display: 'flex' }}>
                            <input type="text" className="span10" defaultValue={item.value} style={{ flex: 1, borderRadius: '4px' }} />
                            {code.toLowerCase().includes('logo') || code.toLowerCase().includes('favicon') ? (
                                <button className="btn" type="button">Duyệt ảnh</button>
                            ) : null}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '4px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '30px' }}>Tùy chỉnh</h3>

            <div className="row-fluid" style={{ display: 'flex' }}>
                <div className="span3" style={{ borderRight: '1px solid #eee', paddingRight: '20px' }}>
                    <ul className="nav nav-list" style={{ padding: 0 }}>
                        {tabs.map(tab => (
                            <li key={tab.id} className={activeTab === tab.id ? 'active' : ''} style={{ marginBottom: '5px' }}>
                                <a href="#" onClick={(e) => { e.preventDefault(); setActiveTab(tab.id); }}
                                    style={{
                                        padding: '10px 15px',
                                        borderRadius: '4px',
                                        backgroundColor: activeTab === tab.id ? '#2891cf' : 'transparent',
                                        color: activeTab === tab.id ? 'white' : '#333',
                                        display: 'block'
                                    }}>
                                    {tab.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="span9" style={{ paddingLeft: '30px' }}>
                    {isLoading ? (
                        <div className="text-center">Đang tải...</div>
                    ) : (
                        <form className="form-horizontal">
                            {activeTab === 'General' && (
                                <>
                                    {renderField('Title Website', 'site_title')}
                                    {renderField('Slogan', 'site_slogan')}
                                    {renderField('Favicion', 'favicon')}
                                    {renderField('Logo', 'logo')}
                                    {renderField('Logo Footer', 'logo_footer')}
                                    {renderField('Copyright', 'copyright', 'textarea')}
                                    {renderField('Thông tin footer', 'footer_info', 'textarea')}
                                </>
                            )}
                            {activeTab === 'LienHe' && (
                                <>
                                    {renderField('Tên công ty', 'company_name')}
                                    {renderField('Địa chỉ', 'company_address')}
                                    {renderField('Hotline', 'company_hotline')}
                                    {renderField('Email', 'company_email')}
                                    {renderField('Điện thoại', 'company_phone')}
                                    {renderField('Fax', 'company_fax')}
                                    {renderField('Google Maps', 'company_map', 'textarea')}
                                </>
                            )}
                            {activeTab === 'Email' && (
                                <>
                                    {renderField('Email nhận liên hệ', 'contact_email')}
                                    {renderField('SMTP Server', 'smtp_server')}
                                    {renderField('SMTP User', 'smtp_user')}
                                    {renderField('SMTP Password', 'smtp_password')}
                                    {renderField('SMTP Port', 'smtp_port')}
                                </>
                            )}
                            {activeTab === 'Social' && (
                                <>
                                    {renderField('Facebook', 'social_facebook')}
                                    {renderField('Youtube', 'social_youtube')}
                                    {renderField('Zalo', 'social_zalo')}
                                    {renderField('Instagram', 'social_instagram')}
                                    {renderField('TikTok', 'social_tiktok')}
                                </>
                            )}
                            {activeTab === 'SEO' && (
                                <>
                                    {renderField('SEO Title', 'seo_title')}
                                    {renderField('SEO Description', 'seo_description', 'textarea')}
                                    {renderField('SEO Keywords', 'seo_keywords')}
                                    {renderField('Google Site Verification', 'google_site_verification')}
                                    {renderField('Bing Site Verification', 'bing_site_verification')}
                                </>
                            )}
                            {activeTab === 'Tools' && (
                                <>
                                    {renderField('Google Analytics ID', 'google_analytics_id')}
                                    {renderField('Facebook Pixel ID', 'facebook_pixel_id')}
                                    {renderField('Google Tag Manager', 'google_tag_manager')}
                                    {renderField('Chat Script', 'chat_script', 'textarea')}
                                </>
                            )}
                            {activeTab === 'Banner' && (
                                <>
                                    {renderField('Banner trang chủ 1', 'banner_home_1')}
                                    {renderField('Banner trang chủ 2', 'banner_home_2')}
                                    {renderField('Banner trang chủ 3', 'banner_home_3')}
                                    {renderField('Banner Sidebar', 'banner_sidebar')}
                                </>
                            )}
                            {activeTab === 'Media' && (
                                <>
                                    {renderField('Facebook Video URL', 'fb_video_url')}
                                    {renderField('Youtube Home URL', 'yt_home_url')}
                                    {renderField('Audio Welcome', 'audio_welcome')}
                                    {renderField('Enable Audio', 'enable_audio')}
                                </>
                            )}
                            {activeTab === 'TamDong' && (
                                <>
                                    <div className="control-group" style={{ marginBottom: '15px', display: 'flex', alignItems: 'center' }}>
                                        <label className="control-label" style={{ width: '150px', fontWeight: 'bold', textAlign: 'right', marginRight: '20px' }}>Trạng thái</label>
                                        <div className="controls" style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                                            <input type="checkbox" defaultChecked={settings.find(s => s.code === 'site_maintenance')?.value === 'true'} style={{ margin: 0, marginRight: '10px' }} />
                                            <span>Mở chức năng đóng Web</span>
                                        </div>
                                    </div>
                                    {renderField('Thông báo bảo trì', 'maintenance_message', 'textarea')}
                                </>
                            )}

                            <div className="form-actions" style={{ marginTop: '30px', padding: '20px 0', borderTop: '1px solid #eee' }}>
                                <button type="submit" className="btn btn-success" style={{ backgroundColor: '#5bb75b', color: 'white', padding: '8px 25px', borderRadius: '4px', border: 'none' }}>
                                    Lưu
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminGeneralSettingPage;
